import MPendingMatchCard from './MPendingMatchCard.vue';

export { MPendingMatchCard };
export default MPendingMatchCard;
